const BETA_INTRO_VIDEO_ID = "uT8QlwYIy-I";

export const BETA_INTRO_VIDEO_EMBED_URL = `https://www.youtube-nocookie.com/embed/${BETA_INTRO_VIDEO_ID}?rel=0`;
export const BETA_INTRO_VIDEO_THUMBNAIL_URL = `https://img.youtube.com/vi/${BETA_INTRO_VIDEO_ID}/maxresdefault.jpg`;
export const BETA_INTRO_ANIMATED_PREVIEW_URL =
  "https://public.replocdn.com/misc/beta-onboarding/replo-agent-demo-v3.gif";
